var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.fields');
    };
  };
};

export default createGetFormMeta;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/selectors/getFormMeta.js
// module id = 1536
// module chunks = 0